// import LayoutNews from "@/layouts/LayoutNews";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/hudong",
  name: "hudong",
  meta: {
    title: "互动交流",
    icon: require('@/assets/images/icons/jiaoliu.png')
  },
  component: () => import("@/views/hudong/index.vue"),
  // component: LayoutNews,
  // redirect: "/hudong/zixun",
  children: [{
      path: "/hudong/zixun",
      name: "网上咨询",
      meta: {
        title: "网上咨询",
        icon: require('@/assets/images/icons/jiaoliu.png')
      },
      component: () => import("@/views/hudong/zixun.vue"),
    },
    {
      path: "/hudong/dafu",
      name: "dafu",
      meta: {
        title: "咨询答复",
        icon: require('@/assets/images/icons/jiaoliu.png')
      },
      component: () => import("@/views/hudong/dafu.vue"),
    },
  ],
}, {
  path: "/hudong-detail",
  name: "hudong-detail",
  meta: {
    title: "互动交流",
    hidden: true,
    icon: require('@/assets/images/icons/jiaoliu.png')
  },
  component: LayoutArticle,
  redirect: "/hudong/detail",
  children: [{
    path: "/hudong/detail",
    name: "hudong_detail",
    meta: {
      title: "",
      hidden: true,
    },
    component: () => import("@/views/hudong/detail.vue"),
  }, ],
}, ]